import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi everyone! I’m <span className="purple">Muhammad Hassaan</span>{" "}
            from <span className="purple">Rawalpindi, Pakistan</span>.
            <br />
            I am currently pursuing a degree in Software Engineering from Foundation University Islamabad and working as a{" "}
            <span className="purple">Software Developer</span> at{" "}
            <span className="purple">ASQ creatives. I also worked as an web developer intern at Common Criteria Pakistan Lab(CCPL)</span>.
            <br />I have earned specialized certifications in{" "}
            <span className="purple">Artificial Intelligence and Responsive Web Design.</span> 
          
            <br />
            <br />
            Outside of coding, I love engaging in activities that keep me
            creative and inspired:
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games 🎮
            </li>
            <li className="about-activity">
              <ImPointRight /> Sports Analysis & Ideas 🏏
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling and Exploring New Places 🌍
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Build. Break. Learn. Repeat."{" "}
          </p>
          <footer className="blockquote-footer">Hassaan</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
